import React from 'react';
import { Box, Typography, Stack, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

const WasteCategories = () => {
    const categories = [
        { name: 'Recyclable Waste', path: '/categories/recycle' },
        { name: 'Organic Waste', path: '/categories/compost' },
        { name: 'Hazardous Waste', path: '/categories/hazardous' },
        { name: 'General Waste', path: '/categories/general' }
    ];

    return (
        <>
            <Typography variant="h6" fontWeight={700} gutterBottom sx={{ color: '#66bb6a' }}>
                ♻️ Categories
            </Typography>
            <Stack spacing={1.5}>
                {categories.map((category) => (
                    <MuiLink
                        key={category.name}
                        component={Link}
                        to={category.path}
                        sx={{
                            color: '#ffffff',
                            textDecoration: 'none',
                            fontWeight: 600,
                            '&:hover': {
                                color: '#66bb6a',
                                textDecoration: 'underline',
                                transform: 'translateX(4px)'
                            },
                            transition: 'all 0.3s ease',
                            fontSize: '0.95rem',
                            opacity: 0.9,
                            '&:hover': {
                                opacity: 1,
                                color: '#81c784'
                            }
                        }}
                    >
                        {category.name}
                    </MuiLink>
                ))}
            </Stack>
        </>
    );
};

export default WasteCategories;
